import { render, staticRenderFns } from "./UnidadeMedida.vue?vue&type=template&id=6ed96cee"
import script from "./UnidadeMedida.vue?vue&type=script&lang=js"
export * from "./UnidadeMedida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports